import TrusonaFull from 'marketing-website/components/icons/TrusonaFull';
import statsImage from 'marketing-website/media/images/pages/case-studies/trusona/stats2@2x.jpg';
import image00a from 'marketing-website/media/images/pages/case-studies/trusona/image_01_a@2x.jpg';
import image00b from 'marketing-website/media/images/pages/case-studies/trusona/image_01_b@2x.jpg';
import image01a from 'marketing-website/media/images/pages/case-studies/trusona/image_02_a@2x.jpg';
import image01b from 'marketing-website/media/images/pages/case-studies/trusona/image_02_b@2x.png';
import singleImage from 'marketing-website/media/images/pages/case-studies/trusona/image_03@2x.jpg';

const trusonaAssets = {
  heroLogo: TrusonaFull,
  statsImage: {
    src: statsImage,
    srcSet: statsImage,
    alt: 'Tursona and Marvel App',
  },
  stats: [
    {
      id: 0,
      stat: '5',
      title: 'mins from paper to prototype',
      copy:
        'Taking rough sketches and turning them into “tappable” prototypes to test before investing time in producing final assets.',
    },
    {
      id: 1,
      stat: '2x',
      title: 'faster meetings with Marvel prototypes',
      copy:
        'Communicating with prototypes means visualizing flows twice as fast.',
    },
    {
      id: 2,
      stat: '4',
      title: 'continents collaborating on a single project',
      copy:
        'Marvel allows Trusona to collaborate across borders and time zones seamlessly.',
    },
  ],
  doubleImages: {
    zero: [
      {
        src: image00a,
        maxWidth: 556,
        alt: 'Marvel on Mobile and Desktop',
      },
      {
        src: image00b,
        maxWidth: 556,
        alt: 'Marvel facilitates Trusona’s workflow',
      },
    ],
    first: [
      {
        src: image01a,
        maxWidth: 550,
        alt: 'Trusona and Marvel Prototyping',
      },
      {
        src: image01b,
        maxWidth: 494,
        alt: 'Trusona and Marvel Prototyping',
      },
    ],
  },
  singleImages: {
    first: {
      src: singleImage,
      maxWidth: 1141,
      alt: 'Trusona and Marvel Prototyping',
    },
  },
};

export default trusonaAssets;



// WEBPACK FOOTER //
// ./src/configs/caseStudies/trusona.js